import { useTranslations } from '@/lib/i18n';
import { Box, Container, Paper, Stack, useMantineTheme } from '@mantine/core';
import { useState } from 'react';
import Logo from '../../components/ui/logo';
import useMetaTitle from '../../hooks/useMetaTitle';
import LoginForm from './LoginForm';
import RequestCodeForm from './RequestCodeForm';

function Login() {
  const t = useTranslations();

  useMetaTitle(t('login_view.title'));

  const theme = useMantineTheme();

  const [otpEmail, setOtpEmail] = useState('');

  return (
    <Box style={{ backgroundColor: theme.colors.gray[1], height: '100vh' }}>
      <Container size={375} py={40}>
        <Stack align="center">
          <Logo />

          <Paper withBorder shadow="md" p={30} mt={30} radius="md" style={{ width: '100%' }}>
            {otpEmail ? <LoginForm email={otpEmail} /> : <RequestCodeForm onReceived={(email) => setOtpEmail(email)} />}
          </Paper>
        </Stack>
      </Container>
    </Box>
  );
}

export default Login;
